import React, { useEffect, useState } from "react";
import {
  FormAutocomplete,
  LabeledAutocomplete,
  formClasses,
  labelClasses,
} from "../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import { responseType } from "../utils/formTypes";
import {
  AtsStckCategoryEdge,
  AtsStckCategoryOrderField,
  GetStockCategoriesResult,
  GetStockCategoriesVars,
} from "../components/modules/asset/masters/category/queries/types";
import { GetStockCategoryForAutocomplete } from "../components/modules/asset/masters/category/queries/queries";
import { useLazyQuery } from "@apollo/client";
import useUrlParams from "../customHooks/useUrlParams";
import { FETCH_MORE_DATA, ROWS_PER_PAGE } from "../utils/constants";
import { OrderDirection } from "../utils/commonQueryTypes";
import { getModifiedScrollHeight } from "../utils/UtilFunctions";
interface Props {
  onKeyDown:
    | ((
        event: React.KeyboardEvent<HTMLDivElement> & {
          defaultMuiPrevented?: boolean;
        }
      ) => void)
    | undefined;
  onChange: (newValue: responseType) => void;
  value: number;
  label: string;
}
const ItemCategorySelect = ({ onChange, onKeyDown, label, value }: Props) => {
  const { customer_id } = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [categories, setCategories] = useState<AtsStckCategoryEdge[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<responseType[]>([]);
  const [autoValue, setAutoValue] = useState<responseType | null>(null);

  const [GetCategories, { data, loading, fetchMore }] = useLazyQuery<
    GetStockCategoriesResult,
    GetStockCategoriesVars
  >(GetStockCategoryForAutocomplete);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetStockCategories.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = categories.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setCategories(updatedNewData);
        setCategoryOptions(
          updatedNewData.map(({ node }) => ({
            label: node.categoryName,
            value: node.id,
          }))
        );
      } else {
        setCategories(newData);
        setCategoryOptions(
          newData.map(({ node }) => ({
            label: node.categoryName,
            value: node.id,
          }))
        );
      }
      setEndCursor(data.GetStockCategories.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const fetchData = async () => {
      try {
  
        if (customer_id) {
          GetCategories({
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckCategoryOrderField.CATEGORY_NAME,
              },
              name: searchData,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [customer_id, GetCategories, searchData]);

  useEffect(() => {
    if (value) {
      const foundValue = categoryOptions.find(
        ({ value: optionsValue }) => Number(optionsValue) === Number(value)
      );

      setAutoValue(foundValue ? foundValue : null);
    } else {
      setAutoValue(null);
    }
  }, [value, data, categoryOptions]);
  const handleScroll = (e: React.UIEvent<HTMLUListElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetStockCategories.edges;
            const pageInfo = fetchMoreResult.GetStockCategories.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetStockCategories.edges.filter(
              ({ node: { id } }) =>
                newEdges.findIndex(
                  ({ node: { id: newId } }) => newId === id
                ) !== -1
            );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetStockCategories: {
                edges: [...categories, ...newEdges],
                pageInfo,
                totalCount: data ? data.GetStockCategories.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  let commonAutocompleteClassName = label
    ? labelClasses.inputRoot
    : formClasses.inputRoot;
  let commonTextFieldClassName = label
    ? labelClasses.formControlRoot
    : formClasses.formControlRoot;

  const Autocomplete =
    label.length > 0 ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      className={commonAutocompleteClassName}
      options={categoryOptions}
      //   onKeyDown={(e) => {
      //     if (e.key === Keys.ENTER) {
      //       e.preventDefault();
      //       handleMUISelectEvent(e);
      //     }
      //   }}
      value={autoValue}
      openOnFocus
      forcePopupIcon
      slotProps={{
        listbox: {
          onScroll: handleScroll,
        },
      }}
      onChange={(e, newValue) => {
        onChange(newValue as responseType);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          onChange={(e) => setSearchData(e.target.value)}
          className={commonTextFieldClassName}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      )}
    />
  );
};

export default ItemCategorySelect;
